import { css } from '@emotion/react';

export const title = css({
  fontWeight: 700,
  fontSize: '56px',
  color: 'white',
  paddingTop: 247
});

export const videoGradiant = css({
  width: 1920,
  height: 1080,
  objectFit: 'cover',
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: -2,
  background:
    'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3))'
});
